import { Injectable } from '@angular/core';
import { Http, Response, Headers } from "@angular/http";
import "rxjs/add/operator/map";

import { Observable } from "rxjs/Observable";
import { HttpHeaders } from '@angular/common/http';
import { TryCatchStmt } from '@angular/compiler';

import { UtilesService } from './utiles.service';
import { VisitaCertificacion } from '../Models/visita-certificacion';
import { Resultado } from '../Models/Resultado';

@Injectable()
export class VisitaCertificacionService {

  constructor( private _http: Http,
    private _utiles: UtilesService) { }



 /**
  * Obtiene la visita certificacion por el idvisita
  * @param compania 
  * @param idvisita 
  */
  ObtenerVisitaCertificacion_idvisita(compania: string, idvisita: string): Observable<VisitaCertificacion[]> {

    try {

      let url = this._utiles.getURL("VisitaCertificacion/" + compania+"/"+idvisita);


      return this._http.get(url).map((response: Response) => {
        return <VisitaCertificacion[]>response.json();
      });

    } catch (error) {

      console.log(error);
    }

  }


}
